export function pickUsingStringAsIndex<T>(string: string, elements: Array<T>): T {
  const stringHash = string
    .split('')
    .map((c) => c.charCodeAt(0))
    .reduce((a, b) => a + b, 0);

  return elements[stringHash % elements.length];
}
